"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Encapsulates binding of product and site, it is not bound to specific use case, use this as data transfer object.
 *
 * @author JMe
 */


var ProductSiteTuple =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSiteTuple, _DomainObject_1$Domai);

  /**
   * @param productId internal id of internal product
   * @param siteId internal id of internal site
   */
  function ProductSiteTuple(productId, siteId) {
    var _this;

    _classCallCheck(this, ProductSiteTuple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteTuple).call(this));
    _this.productId = productId;
    _this.siteId = siteId;
    return _this;
  }

  _createClass(ProductSiteTuple, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductSiteTuple) {
        return other.productId === this.productId && other.siteId === this.siteId;
      }

      return false;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.productId + '-' + this.siteId);
    }
  }]);

  return ProductSiteTuple;
}(DomainObject_1.DomainObject);

exports.ProductSiteTuple = ProductSiteTuple;
/**
 * Stores key under which product/site tuples are stored within {@link CreateAndStoreReleasePartsResult#data data object}.
 *
 * JMe: I do not think this is a good pattern (it is quite horrible), refactor whole design if time
 */

ProductSiteTuple.RELEASE_PARTS_CREATION_RESULT_TUPLES_KEY = 'productSiteTuples';